export const demo10 = {
  "appBar": {
    "backgroundColor": "#B8C7C4",
    "mode": "light",
    "exhibition": {
      "name": "Boring",
      "description": "Boring i Ekofiskområdet omfatter leteboring og produksjonsboring. Ved leteboring gjelder det selvsagt å finne olje og gass, mens det ved produksjonsboring er om å gjøre å få ressursene ut. Da gjelder det å få plassert brønnene riktig, slik at man kan få tappet reservoaret mest mulig.",
      "url": "https://ekofisk.industriminne.no/nb/boring/"
    },
    "museum": {
      "name": "Virtuelt Museum",
      "url": "https://virtueltmuseum.no"
    }
  },
  "sections": [
    {
      "title": "Forside",
      "type": "sticky",
      "order": 1,
      "templateId": 5,
      "gridSize": "nineColumns",
      "backgroundImage": "https://ems-test.dimu.org/image/062waVTfU2pP?dimension=2048x2048",
      "backgroundFocus": {
        "x": 0.0,
        "y": 0.5
      },
      "containers": [
        {
          "startColumn": 4,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Overskrift",
              "text": "{\"blocks\": [{\"key\": \"71dc0\", \"text\": \"Boring\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 6, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 6, \"style\": \"FONT_SIZE_48\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"center\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Forfatter",
              "text": "{\"blocks\": [{\"key\": \"ce90a\", \"text\": \"Av Nettartikkel\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 15, \"style\": \"FONT_SIZE_16\"}, {\"offset\": 0, \"length\": 15, \"style\": \"color-555555\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"center\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Ingress",
              "text": "{\"blocks\": [{\"key\": \"671b5\", \"text\": \"Boring i Ekofiskområdet omfatter leteboring og produksjonsboring. Ved leteboring gjelder det selvsagt å finne olje og gass, mens det ved produksjonsboring er om å gjøre å få ressursene ut. Da gjelder det å få plassert brønnene riktig, slik at man kan få tappet reservoaret mest mulig.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 284, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 284, \"style\": \"FONT_SIZE_20\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"center\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Scroll instruks",
              "text": "{\"blocks\": [{\"key\": \"d7e94\", \"text\": \"SCROLL FOR Å LESE\\n↓\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 19, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 19, \"style\": \"FONT_SIZE_12\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"center\"}}], \"entityMap\": {}}"
            }
          ]
        },
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"5316b\", \"text\": \"INNLEDNING\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 10, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 10, \"style\": \"FONT_SIZE_12\"}, {\"offset\": 0, \"length\": 10, \"style\": \"color-666666\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Nøkkelinnsikt",
              "text": "{\"blocks\": [{\"key\": \"d5967\", \"text\": \"Ut fra den kunnskapen og utstyret som var til disposisjon, var brønnene gode, men de var ikke egnet til å «støvsuge» reservoaret.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 129, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 129, \"style\": \"FONT_SIZE_20\"}, {\"offset\": 0, \"length\": 129, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 2,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#FCF1E3",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"e399d\", \"text\": \"Innledning\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 10, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 10, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 10, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"b4764\", \"text\": \"De første brønnene som ble boret på Ekofisk er veldig primitive i forhold til brønnene som bores i dag. Ut fra den kunnskapen og utstyret som var til disposisjon, var brønnene gode, men de var ikke egnet til å «støvsuge» reservoaret. Blant annet var det ikke mulig å bore horisontalt. Når brønnen kom opp i 70 grader, ble de tidligere ansett nærmest som horisontale. I dag bores det horisontalt og til og med oppoverbakke. Den teknologiske utviklingen som har gjort dette mulig, startet på slutten av 1980-tallet og ble utviklet videre på 1990-tallet.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 551, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 551, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"49bbc\", \"text\": \"Borejobben har gjennom årene blitt utført av en rekke kontraktører. I de første årene var det de samme boreselskapene som ble benyttet, men de skiftet navn. Et av selskapene var Moran Brothers som i løpet av sin tid på Ekofisk ble til Morco, så Norcem Drilling, deretter Aker Drilling og til sist Transocean Drilling. Boremannskapene fra disse selskapene sto for driften av selve riggen. I 2001 var det boreselskapene Deutag Norge Drilling, Smedvig Offshore og Mærsk Drilling, nå Mærsk Contractors, som var engasjert i Ekofiskområdet. Til sammen har de tre kontraktørene rundt 500 ansatte som jobbet for Phillips, i Ekofiskområdet, eller på land. Ved bruk av moderne datateknologi og fiberoptiske kabler er operatørselskapet i dag i stand til å følge operasjonene offshore fra hovedkontoret i det boringen faktisk skjer.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 820, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 820, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"e0ffb\", \"text\": \"Når det gjelder tjenester på sementering har Dowell, Haliburton og BJ Services blitt benyttet.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 94, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 94, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"4a4b8\", \"text\": \"De som sto for retningsboringen var Eastman, Sperry Sun eller Target Drilling som var et Aker Drilling selskap. I 2001 ble selskapet Pathfinder engasjert med retningsboring som hovedfelt.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 187, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 187, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"9dce7\", \"text\": \"Logging har blitt drevet av Schlumberger eller Atlas. Weatherford har vært på banen med casingtjenester (foringsrørtjenester). Borevesketjenester har vært levert av blant andre Milchem, Ceca, MI, Anchor Drilling Fluids.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 219, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 219, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "Boreoperasjonssjef",
      "type": "sticky",
      "order": 3,
      "templateId": 5,
      "gridSize": "nineColumns",
      "backgroundImage": "https://ems-test.dimu.org/image/062waVTfUNNg?dimension=2048x2048",
      "backgroundFocus": {
        "x": 0.0,
        "y": 0.5
      },
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"f8955\", \"text\": \"BOREOPERASJONSSJEF\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 18, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 18, \"style\": \"FONT_SIZE_12\"}, {\"offset\": 0, \"length\": 18, \"style\": \"color-666666\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Nøkkelinnsikt",
              "text": "{\"blocks\": [{\"key\": \"2c235\", \"text\": \"En ting som var spesielt for Phillips på 1970- og 1980-tallet var at det var en sentral boreoperasjonssjef for alle installasjonene.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 132, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 132, \"style\": \"FONT_SIZE_20\"}, {\"offset\": 0, \"length\": 132, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 4,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#ffffff",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"c3217\", \"text\": \"Boreoperasjonssjef\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 18, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 18, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 18, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"0e9d7\", \"text\": \"En ting som var spesielt for Phillips på 1970- og 1980-tallet var at det var en sentral boreoperasjonssjef for alle installasjonene. Boreoperasjonssjefen, som var en ansatt i Phillips, satt som koordinerende punkt på Ekofisk 2/4 H. Alle borelederne rapporterte til ham, som igjen samlet sine rapporter til boreavdelingen på land.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 329, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 329, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 5,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#FCF1E3",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"5c0ce\", \"text\": \"Boreleder\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 9, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 9, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 9, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"32ac7\", \"text\": \"Borelaget ble ledet av Phillips sin boreleder (Drilling Supervisor). I de første årene på Ekofisk var det bare én boreleder fra Phillips om bord, og han hadde døgnvakt. Det vil si at han hadde sengen sin på kontoret og sov og jobbet fra samme rom. Etter Bravo-utblåsningen ble det innført en ordning med nestkommanderende på riggen, assisterende (junior) boreleder som gikk nattskiftet. Han ble gjerne kalt for nattmann.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 420, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 420, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"7a84f\", \"text\": \"Borelaget var bemannet med folk fra flere kontraktørselskap, som hver var spesialister på forskjellige tjenester. Borelaget besto av boresjef, borere, tårnmenn, boredekksarbeidere og hjelpearbeidere – foruten bistand av elektrikere, mekanikere, materialmenn og i begynnelsen også kranførere.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 291, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 291, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "Boresjef",
      "type": "sticky",
      "order": 6,
      "templateId": 5,
      "gridSize": "nineColumns",
      "backgroundImage": "https://ems-test.dimu.org/image/062waVTfUNNf?dimension=2048x2048",
      "backgroundFocus": {
        "x": 0.0,
        "y": 0.5
      },
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"b402c\", \"text\": \"BORESJEF\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 8, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 8, \"style\": \"FONT_SIZE_12\"}, {\"offset\": 0, \"length\": 8, \"style\": \"color-666666\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Nøkkelinnsikt",
              "text": "{\"blocks\": [{\"key\": \"1f55c\", \"text\": \"Boresjefen er lederen for borelaget hvor alle er ansatt i borekontraktørselskapet som har kontrakten om bord på den respektive plattformen.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 139, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 139, \"style\": \"FONT_SIZE_20\"}, {\"offset\": 0, \"length\": 139, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 7,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#FCF1E3",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"c7a86\", \"text\": \"Boresjef\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 8, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 8, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 8, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"fd0b8\", \"text\": \"Boresjefen er lederen for borelaget hvor alle er ansatt i borekontraktørselskapet som har kontrakten om bord på den respektive plattformen. Boresjefen følger med mannskapet og ser etter at rutiner, særlig ting som angår sikkerheten blir fulgt opp. Boringen skal utføres slik operatøren har planlagt i Tananger, planer som igjen er godkjent av Oljedirektoratet.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 360, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 360, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"30732\", \"text\": \"Boresjefen i tett samarbeid med borelederen, overvåker, samler og registrerer boretekniske data, og holder kontinuerlig kontakt med operatørselskapets boreoperasjonssjef på Ekofisk. Ved spesielle operasjoner blir det tilkalt ingeniører fra land.Kvendseth, Stig S, Giant Discovery. A History of Ekofisk Through the First 20 Years, 1988.Boresjefen kan også avløse boreren i matpausen og deltar i varierende grad i arbeidsoperasjoner som blir utført.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 447, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 447, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "Borer (bore- og vedlikeholdsoperatør)",
      "type": "sticky",
      "order": 8,
      "templateId": 5,
      "gridSize": "nineColumns",
      "backgroundImage": "https://ems-test.dimu.org/image/062waVTfUNNe?dimension=2048x2048",
      "backgroundFocus": {
        "x": 0.0,
        "y": 0.5
      },
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"debf0\", \"text\": \"BORER (BORE- OG VEDLIKEHOLDSOPERATØR)\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 37, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 37, \"style\": \"FONT_SIZE_12\"}, {\"offset\": 0, \"length\": 37, \"style\": \"color-666666\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Nøkkelinnsikt",
              "text": "{\"blocks\": [{\"key\": \"c8f1d\", \"text\": \"Boreren leder det daglige arbeidet etter instrukser fra boresjefen.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 67, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 67, \"style\": \"FONT_SIZE_20\"}, {\"offset\": 0, \"length\": 67, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 9,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#FCF1E3",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"c7d47\", \"text\": \"Borer (bore- og vedlikeholdsoperatør)\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 37, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 37, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 37, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"163bf\", \"text\": \"Boreren leder det daglige arbeidet etter instrukser fra boresjefen. Fra borebua opererer han utstyret som brukes under boreoperasjonene. Han har kontroll med de ulike boreparameter som trykk, drillbarhet, dreiemoment og slamflyt, og ser til at alt fungerer som det skal. Da norske boreentreprenører inntok denne bransjen, utvidet de borelaget med en funksjon. De opprettet stillingen som boreassistent (assistant driller).\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 422, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 422, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"7450e\", \"text\": \"En tendens fra den tidlige leteboringen fram til i dag har vært at mindre og mindre av den samlede riggtiden går med til å føre borestrengen ut og inn av brønnen. Dette skyldes at borekronen ikke skiftes så ofte som før, samt at det har blitt mulig å foreta målinger i brønnen mens det bores. Også i dag må hele borestrengen opp når borekronen skal skiftes, men borekronen har fått lenger levetid. Det skyldes mer viten om hva som gjør at borekroner slites og at det er bedre kvalitet på borekronen.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 499, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 499, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"13b6c\", \"text\": \"I dag styres mye av arbeidet fra den moderne borebua med fysiologisk utformede stoler (12-timers stoler). Boreutstyret er datastyrt ved hjelp av joystick og tastatur på armlenene. Det datastyrte boreutstyret (roboter) utfører mye av arbeidet boredekksarbeideren (roughnecken), hjelpearbeideren (roustabouten) og tårnmannen gjorde tidligere.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 340, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 340, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"74f91\", \"text\": \"Boring utgjør hovedaktiviteten frem til komplettering for produksjon, prøveproduksjon, trykkstøtte og/eller tilbakeplugging av brønner. En faglært bore- og vedlikeholdsoperatør skal kunne delta i alle faser av boreoperasjonen. De skal kunne føre kontroll med, og holde vedlike boreslam og boreslamsystemer og kunne utføre førstelinjevedlikehold av trykkontrollsystemer og utstyr, samt boreslam og utstyr.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 404, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 404, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "Retningsborer og MWD",
      "type": "sticky",
      "order": 10,
      "templateId": 5,
      "gridSize": "nineColumns",
      "backgroundImage": "https://ems-test.dimu.org/image/062waVTfU2tf?dimension=2048x2048",
      "backgroundFocus": {
        "x": 0.0,
        "y": 0.5
      },
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"96484\", \"text\": \"RETNINGSBORER OG MWD\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 20, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 20, \"style\": \"FONT_SIZE_12\"}, {\"offset\": 0, \"length\": 20, \"style\": \"color-666666\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Nøkkelinnsikt",
              "text": "{\"blocks\": [{\"key\": \"6cb25\", \"text\": \"Denne informasjonen brukes av retningsborer som «styrer» brønnen i henhold til en brønnplan.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 92, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 92, \"style\": \"FONT_SIZE_20\"}, {\"offset\": 0, \"length\": 92, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 11,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#FCF1E3",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"bf7b7\", \"text\": \"Retningsborer og MWD\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 20, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 20, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 20, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"fa2f7\", \"text\": \"Ved å bore produksjonsbrønner ved hjelp av retningsboring, oppnår en å drenere større deler av et olje- eller gassreservoar fra en enkelt installasjon. Denne teknologien ble utviklet på slutten av 1980-tallet og videre framover. Det er gjerne ansatte i operatørselskapet som er spesialister på retningsboring.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 309, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 309, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"03c9d\", \"text\": \"Retningsboring starter som vanlig rotasjonsboring, men går deretter over i en fase der det bygges opp en viss vinkel i forhold til vertikalplanet. I denne fasen roterer ikke borestrengen, men borekronen drives rundt ved at borevæsken som pumpes ned gjennom borestrengen driver rundt skovlene i en turbin (nedenhullsmotor) over borekronen. Når den ønskede vinkelen er oppnådd går en tilbake til vanlig rotasjonsboring.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 417, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 417, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"e853d\", \"text\": \"Horisontal boring er en videreutvikling av retningsboring for å nå ut i alle deler av reservoaret. I enkelte reservoar kan oljen ligge i tynne lag og da er det viktig å kunne utvikle horisontale brønner. Det gjør at utvinningsgraden fra oljefelt øker betydelig. Baker Hughes Inteq har laget et system der boret styres ved hjelp av styrbare motorer kalt AutoTrack. Det gjør det mulig å endre retning og vinkel kontinuerlig mens man borer. Kommandoene styres via en datamaskin. Det er sensorer på borestrengen som analyserer bergarten det bores i slik at en styrer borekronen inn i de riktige geologiske strukturene.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 614, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 614, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"1d2fc\", \"text\": \"MWD står for Measurement While Drilling (Måling Under Boring, på godt norsk). Stillingen går ut på å operere MWD-utstyret, samt behandle, presentere, evaluere og kvalitetssikre den informasjonen som MWD-utstyret samler inn og sender opp til overflaten mens det bores.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 267, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 267, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"f4f92\", \"text\": \"Directional (retnings-) målinger gir informasjon om hvilken retning (azimuth) og vinkel (inclination) brønnen har. Denne informasjonen brukes av retningsborer som «styrer» brønnen i henhold til en brønnplan.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 207, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 207, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"d1e35\", \"text\": \"En rekke forskjellige sensorer tar ulike målinger av formasjonen det bores gjennom. Målingene presenteres som kurver på logger og brukes til formasjonsevaluering. Det vil si at dataene tolkes til hva slags bergart det bores gjennom ( som for eksempel sandstein, leirstein eller kalkstein), hva slags væske denne bergarten inneholder (vann, olje eller gass) og andre egenskaper som for eksempel porøsiteten til bergarten. Loggene blir evaluert (tolket) av både MWD-ingeniøren og geologer offshore, samt petrofysikere og geologer på land. Sammen med analyser av borekaks som blir samlet inn av mudlogger, gir disse dataene et godt bilde av formasjonen rundt brønnen. Ofte brukes MWD-dataene aktivt av geologene til å holde brønnen i ønskede formasjonslag. Dette kalles geosteering.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 779, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 779, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"d1ea2\", \"text\": \"Det sendes også opp målinger som kan brukes til å optimalisere boreparametrene og redusere skadene på utstyret nede i brønnen, samt trykkmålinger som gir oss indikasjoner på om vi har god eller dårlig hullrensing, det vil si om borekakset transporteres ut av hullet eller om det hoper seg i brønnen og til slutt kan føre til at en sitter fast.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 343, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 343, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"0428e\", \"text\": \"Det har de siste ti årene vært en rivende utvikling innen MWD-utstyr. Da AutoTrak, som ga muligheten til å rotere borestrengen samtidig som man kunne styre, ble introdusert på midten/slutten av 1990-tallet åpnet det helt nye muligheter innen retningsboring og geosteering. Det er fortsatt en kontinuerlig utvikling av ny teknologi og anvendelse av den informasjonen dette gir oss.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 380, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 380, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 12,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#ffffff",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"be090\", \"text\": \"Tårnmann\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 8, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 8, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 8, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"0a99a\", \"text\": \"Tårnmannen var tillagt to hovedoppgaver. Han deltok i det som kalles trippeoperasjonen (å føre borestrengen ut og inn av brønnen) og sørget for at boreslammet ble riktig blandet.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 178, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 178, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"56ae6\", \"text\": \"Under trippingen var tårnmannen engasjert sammen med borer og boredekksarbeidere. Under denne arbeidsoperasjonen sto tårnmannen i boretårnet, og boredekksarbeiderne var på boredekket. Borestrengen ble trukket ut av hullet og ble koblet fra i lengder på tre og tre borerør (stand). Tårnmannens oppgave var å ta imot slike stand på tre rørlengder. Omvendt styrte tårmannen standene fra fingerbordet når borestrengen skulle ned i hullet igjen. Tårnmannen utførte ganske tunge arbeidsoppgaver fra en liten plattform på én kvadratmeter, 30 meter over boredekk. Arbeidsstillingen var å stå lent ut over plattingen hvor han støttet hoftepartiet med et stramt tau slik at han ikke falt ned.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 682, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 682, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"bd95c\", \"text\": \"Fra midten av 1970-tallet startet mekaniseringen og automatiseringen av arbeidet på boredekk. Blant annet ble tårnmannens oppgave under trippingen mekanisert. Tårnmannen betjente et mekanisk rørhåndteringssytem som grep fatt i røret (standet) og plasserte det i fingerbordet når borestrengen ble dradd opp og omvendt styrte røret ved hjelp av dette rørhåndteringssystemet til elevator, når røret skulle ned i brønnen.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 417, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 417, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"23c36\", \"text\": \"Når tårnmannen ikke er opptatt med tripping i forbindelse med boring så arbeider han i slamrommet. Han skal hele tiden sørge for at boreslammet blir blandet etter boreingeniørens instrukser.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 190, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 190, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "Boredekksarbeider (roughneck)",
      "type": "sticky",
      "order": 13,
      "templateId": 5,
      "gridSize": "nineColumns",
      "backgroundImage": "https://ems-test.dimu.org/image/062waVTfU2ju?dimension=2048x2048",
      "backgroundFocus": {
        "x": 0.0,
        "y": 0.5
      },
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"389de\", \"text\": \"BOREDEKKSARBEIDER (ROUGHNECK)\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 29, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 29, \"style\": \"FONT_SIZE_12\"}, {\"offset\": 0, \"length\": 29, \"style\": \"color-666666\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Nøkkelinnsikt",
              "text": "{\"blocks\": [{\"key\": \"bed5c\", \"text\": \"Det var to til tre boredekksarbeidere som «satte slipset» (en bærbar kileformet låseanordning).\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 95, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 95, \"style\": \"FONT_SIZE_20\"}, {\"offset\": 0, \"length\": 95, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 14,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#ffffff",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"b1193\", \"text\": \"Boredekksarbeider (roughneck)\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 29, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 29, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 29, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"7ffe7\", \"text\": \"Boredekksarbeiderne utførte det manuelle grovarbeidet på boredekket (flooren, drillflooren) og på kjellerdekket (cellardeck, dekk på nederste nivå, under boredekket). Ved kobling og brekking (frakobling) av rør, festet de tengene som boreren brakk rørledningen med. Ved begynnelsen av 1970-tallet gikk boredekksarbeideren over til å operere en «spinner», en hydraulisk tang som spant gjengkoblingene mellom rørene fra hverandre.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 428, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 428, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"7be85\", \"text\": \"Det var to til tre boredekksarbeidere som «satte slipset» (en bærbar kileformet låseanordning). Slipset veier mellom 40 – 50 kg. Boredekksarbeideren løftet slipset bort til borestrengen og satte den rundt den slik at borestrengen ble kilt fast i hullet i boredekket. Slik kunne borestrengen henge i slipset når den var frigjort fra heiseverket.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 344, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 344, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"eb46a\", \"text\": \"Boredekksarbeideren hadde også ansvar for rengjørings- og vedlikeholdsarbeidet på boredekket (vaskemiddelet var caustic soda og diesel). Dessuten kunne de trekkes inn for å assistere servicefirmaene i deres forskjellige gjøremål.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 229, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 229, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"a93b2\", \"text\": \"På kjellerdekk (cellardekket) monterte og klargjorde boredekksarbeideren ulike utstyrsenheter under oppsyn eller i samarbeid med overordnede eller spesialarbeidere. Blant annet montertes der ulike størrelser av sikkerhetsventiler (BOP – Blow out preventer) mot utblåsning. På kjellerdekket ble også stigerøret festet. Forskjellige dimensjoner av foringsrør ble hengt av, ventiltre montert, og høytrykksledninger som fører hydrokarboner ut på utsiden av riggen under testing, koblet til. Ellers hjalp boredekksarbeideren til med å blande boreslam og stå vakt ved «shale shaker» (vibrerende rister som renser returslam).Kvendseth, Stig S, Giant Discovery. A History of Ekofisk Through the First 20 Years, 1988.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 708, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 708, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"66bdb\", \"text\": \"Nå er mye av boredekksarbeiderens arbeidsoppgaver erstattet av en «ironroughneck», en robot som styres av boreren fra borebua. Men boredekksarbeideren må likevel bevege seg på boredekket blant annet for å smøre forskjellig utstyr.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 230, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 230, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "image",
              "imagePath": "https://ems-test.dimu.org/image/062waVTfU2ju?dimension=2048x2048",
              "altText": "Boredekksarbeider (roughneck)",
              "caption": "arbeidsliv, feltorganisasjon, første driftsfase, boredekk, boring,",
              "showCaptionIcon": true,
              "textAlign": "center"
            }
          ]
        }
      ]
    },
    {
      "title": "Sementerer / brønnoperatør",
      "type": "sticky",
      "order": 15,
      "templateId": 5,
      "gridSize": "nineColumns",
      "backgroundImage": "https://ems-test.dimu.org/image/062waVTfUNNd?dimension=2048x2048",
      "backgroundFocus": {
        "x": 0.0,
        "y": 0.5
      },
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"352e7\", \"text\": \"SEMENTERER / BRØNNOPERATØR\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 26, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 26, \"style\": \"FONT_SIZE_12\"}, {\"offset\": 0, \"length\": 26, \"style\": \"color-666666\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Nøkkelinnsikt",
              "text": "{\"blocks\": [{\"key\": \"393fb\", \"text\": \"Sementering inngår i hele prosessen fra leteboring til ferdigstillelse for produksjon og senere vedlikeholdsarbeid i oljebrønnen.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 129, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 129, \"style\": \"FONT_SIZE_20\"}, {\"offset\": 0, \"length\": 129, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 16,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#ffffff",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"00bf8\", \"text\": \"Sementerer / brønnoperatør\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 26, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 26, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 26, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"a9076\", \"text\": \"Sementering inngår i hele prosessen fra leteboring til ferdigstillelse for produksjon og senere vedlikeholdsarbeid i oljebrønnen. Brønnoperatøren innen sementering er de siste som forlater plattformen etter å ha sementert igjen brønnen ved nedstengning. Arbeidet som sementerer er variert og stiller store krav til teoretiske og praktiske ferdigheter. Arbeidsoppgavene kan deles inn i tre hovedområder: Sementering, trykktesting og bruk av brønnverktøy.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 453, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 453, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"a9314\", \"text\": \"Når man starter å bore, begynner en med store borekroner (75 – 90 cm i diameter). Senere skiftes det til mindre og mindre borekroner jo lenger ned det bores. De minste er som regel 15 cm i diameter. Når det skal skiftes til en mindre borekrone, trekkes hele borestrengen opp, og borerøret fôres med stålrør (casing). Fôringen kan være flere hundre meter. Før en kan bore videre pumpes det sement ned i borehullet, slik at sementen presses opp på utsiden av fôringsrørene. Poenget med sementering er å støpe rørene fast til brønnveggen. Dette forhindrer at veggen raser sammen, og det stopper olje og gass fra å trenge ukontrollert opp til overflaten på utsiden av fôringen.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 673, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 673, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"b5be9\", \"text\": \"Normalt sett skal sementering være en enkel jobb. Volumet som skal fylles med sement må beregnes på forhånd, og så er det bare å pumpe ned denne mengden. Jobben må gå raskt, derfor er det viktig at den er godt forberedt. Tidligere måtte den som ledet sementeringsarbeidet kjenne pumpen så og si personlig. Pumpen må arbeide effektivt (med så og så mange pumpeslag) hele tiden slik at en er sikker på at hele rommet rundt røret fylles med sement. Ellers vil det oppstå problemer med brønnen i etterkant. I dag drives pumpene elektrisk og en leser pumpeeffekten ved hjelp av instrumenter.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 586, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 586, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"dcac9\", \"text\": \"For å pumpe sement trengs det mud. Når en skal skifte fra en tank til en annen må en stenge og åpne ventiler og det oppstår et trykk.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 133, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 133, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "Casingoperatør",
      "type": "sticky",
      "order": 17,
      "templateId": 5,
      "gridSize": "nineColumns",
      "backgroundImage": "https://ems-test.dimu.org/image/062waVTfU2pK?dimension=2048x2048",
      "backgroundFocus": {
        "x": 0.0,
        "y": 0.5
      },
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"0c149\", \"text\": \"CASINGOPERATØR\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 14, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 14, \"style\": \"FONT_SIZE_12\"}, {\"offset\": 0, \"length\": 14, \"style\": \"color-666666\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Nøkkelinnsikt",
              "text": "{\"blocks\": [{\"key\": \"9d089\", \"text\": \"Etter hvert som det bores nedover i berglagene, settes det foringsrør (casing) som sementeres fast i borehullet.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 112, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 112, \"style\": \"FONT_SIZE_20\"}, {\"offset\": 0, \"length\": 112, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 18,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#ffffff",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"8f696\", \"text\": \"Casingoperatør\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 14, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 14, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 14, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"92b78\", \"text\": \"Etter hvert som det bores nedover i berglagene, settes det foringsrør (casing) som sementeres fast i borehullet. Diameteren på foringsrørene avtar nedover i borehullet. Foringsrørets oppgave er å stive av borehullet slik at det ikke raser sammen. Det er også en viktig returkanal for boreslammet, og dessuten isolerer det problemfylte soner i berglagene, for eksempel soner med spesielt høyt eller lavt trykk.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 409, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 409, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"c4d1b\", \"text\": \"Det er egne firma som leverer foringsrørene. De beregner hvor mye som trengs av hvilke typer rør til et hull og sørger for at utstyret er på plass til rett tid. Casingoperatøren håndterer rørene, men i de senere årene har denne arbeidsoperasjonen blitt mer automatisert.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 270, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 270, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 19,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#FCF1E3",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"7e5a9\", \"text\": \"Mudlogger og geolog\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 19, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 19, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 19, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"808bd\", \"text\": \"Mudloggeren eller mudingeniøren har som oppgave å samle inn boredata. Det skjer enten fra instrumenter på overflaten eller fra instrumenter nede i borestrengen. Parametrene de følger med på er borehullets dybde, borehastighet, vekt på borekronen, rotasjonshastighet, boreslammets tetthet, gassinnholdet i boreslammet, tiden som borekakset bruker på veien opp fra borekronen til riggen, parametre som indikerer forandringer i poretrykket, det vil si det indre trykket i bergartens porer.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 486, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 486, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"03d94\", \"text\": \"Kontinuerlig observasjon av disse boreparametre kan gi viktig informasjon om ustabile forhold nede i hullet, og eventuelt forhindre ulykker, som ukontrollerte utblåsninger eller at hullet kollapser og borestrengen setter seg fast. Boreparametre kan også gi indikasjoner på geologiske variasjoner. Dersom det ved boring i en skiferbergart blir en økning i borehastigheten, kan dette tyde på at borekronen er kommet inn i en sandstein (som er en reservoarbergart).\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 462, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 462, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"849f4\", \"text\": \"Mudloggeren foretar blant annet innsamling og vasking av borekakset som igjen analyseres av geologen om bord på riggen. Basert på denne analysen lager borestedsgeologen en oversikt som viser bergartene det er boret gjennom.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 223, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 223, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "Borelogger",
      "type": "sticky",
      "order": 20,
      "templateId": 5,
      "gridSize": "nineColumns",
      "backgroundImage": "https://ems-test.dimu.org/image/062waVTfUNNc?dimension=2048x2048",
      "backgroundFocus": {
        "x": 0.0,
        "y": 0.5
      },
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"94beb\", \"text\": \"BORELOGGER\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 10, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 10, \"style\": \"FONT_SIZE_12\"}, {\"offset\": 0, \"length\": 10, \"style\": \"color-666666\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Nøkkelinnsikt",
              "text": "{\"blocks\": [{\"key\": \"b2930\", \"text\": \"Logging går ut på å senke måleinstrumenter ned i brønnen for å måle forskjellige fysiske egenskaper ved reservoarlagene eller ...\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 129, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 129, \"style\": \"FONT_SIZE_20\"}, {\"offset\": 0, \"length\": 129, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 21,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#FCF1E3",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"a7f67\", \"text\": \"Borelogger\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 10, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 10, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 10, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"4462d\", \"text\": \"Logging går ut på å senke måleinstrumenter ned i brønnen for å måle forskjellige fysiske egenskaper ved reservoarlagene eller væsken i reservoaret (olje, gass eller vann). Eksempler på slike egenskaper kan være naturlig radioaktivitet, tetthet i reservoarlagene, lydhastighet, elektrisk motstandsevne og temperatur.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 315, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 315, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"3792f\", \"text\": \"Logging kan foregå under forskjellige forhold:\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 46, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 46, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "Brønntesting",
      "type": "sticky",
      "order": 22,
      "templateId": 5,
      "gridSize": "nineColumns",
      "backgroundImage": "https://ems-test.dimu.org/image/062waVTjufQb?dimension=2048x2048",
      "backgroundFocus": {
        "x": 0.0,
        "y": 0.5
      },
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "stepPosition": "bottom",
          "backgroundColor": "#fffffff2",
          "borderRadius": true,
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"44884\", \"text\": \"BRØNNTESTING\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 12, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 12, \"style\": \"FONT_SIZE_12\"}, {\"offset\": 0, \"length\": 12, \"style\": \"color-666666\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Nøkkelinnsikt",
              "text": "{\"blocks\": [{\"key\": \"275df\", \"text\": \"Dersom loggene og eventuelt kjernene viser at noen av bergartslagene dypt nede i borehullet inneholder olje og gass, blir det ...\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 129, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 129, \"style\": \"FONT_SIZE_20\"}, {\"offset\": 0, \"length\": 129, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "",
      "type": "content",
      "order": 23,
      "templateId": 2,
      "minHeight": "50vh",
      "verticalAlign": "center",
      "backgroundColor": "#FCF1E3",
      "containers": [
        {
          "startColumn": 5,
          "endColumn": 6,
          "horizontalAlign": "center",
          "blocks": [
            {
              "type": "text",
              "placeholder": "Kapitteltittel",
              "text": "{\"blocks\": [{\"key\": \"b4ba2\", \"text\": \"Brønntesting\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 12, \"style\": \"BOLD\"}, {\"offset\": 0, \"length\": 12, \"style\": \"FONT_SIZE_24\"}, {\"offset\": 0, \"length\": 12, \"style\": \"color-1a1a1a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            },
            {
              "type": "text",
              "placeholder": "Tekst",
              "text": "{\"blocks\": [{\"key\": \"72328\", \"text\": \"Dersom loggene og eventuelt kjernene viser at noen av bergartslagene dypt nede i borehullet inneholder olje og gass, blir det vanligvis utført en produksjonstest. Denne utføres ved at oljen eller gassen får strømme kontrollert opp til jordens overflate. Det foretas målinger blant annet av hvor raskt oljen/gassen strømmer opp gjennom borehullet, og det blir tatt prøver av selve oljen/gassen. Arbeidet ledes gjerne av en reservoaringeniør. Med testingen er vanligvis leteboringen ferdig. Borehullet plugges ved sementering, det blir foretatt opprydding på havbunnen og borestedet forlates.\", \"type\": \"unstyled\", \"depth\": 0, \"inlineStyleRanges\": [{\"offset\": 0, \"length\": 590, \"style\": \"FONT_SIZE_18\"}, {\"offset\": 0, \"length\": 590, \"style\": \"color-2a2a2a\"}], \"entityRanges\": [], \"data\": {\"text-align\": \"left\"}}], \"entityMap\": {}}"
            }
          ]
        }
      ]
    },
    {
      "title": "3.-Boring.mp4",
      "type": "content",
      "order": 24,
      "templateId": 5,
      "gridSize": "nineColumns",
      "containers": [
        {
          "startColumn": 3,
          "endColumn": 7,
          "horizontalAlign": "center",
          "stepPosition": "center",
          "backgroundColor": "#ffffffff",
          "borderRadius": true,
          "blocks": [
            {
              "type": "video",
              "videoUrl": "https://ems-test.dimu.org/streaming/adaptive/062waVTjufQb/index.m3u8",
              "url": "https://ems-test.dimu.org/streaming/adaptive/062waVTjufQb/index.m3u8",
              "poster": "https://ems-test.dimu.org/image/062waVTjufQb?dimension=2048x2048",
              "showControls": true,
              "caption": "3.-Boring.mp4"
            }
          ]
        }
      ]
    }
  ]
};

export const demo10_boring = demo10;
